import * as React from "react";
import '/node_modules/rsuite/dist/rsuite.min.css';
import { Empty, Table, Card, Space, Popover, Input, Button, Spin } from "antd"
import { useCallback, useState } from 'react';
import '/node_modules/rsuite/dist/rsuite.min.css';
import { InfoCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { Download } from 'react-feather';
import { OperationsDownloadReports } from "./modals/OperationsDownloadReportsModal";
import { AppContext } from "../../context/AppContext";


const boxIcon = require('../../assets/images/box-icon.png')
const giftLogo = require('../../assets/images/gift-logo.png')
const starIcon = require('../../assets/icons/blue-star-icon.png')

export const OperationsListOfPartners = () => {
    const context = React.useContext(AppContext);
    const { onGetOperationsPointsValues, onGetListOfPartners } = context;
    const [searchText, setSearchText] = React.useState("")
    const [loading, setLoading] = React.useState(false)
    const [partners, setPartners] = React.useState([])
    const [selectedPartner, setSelectedPartner] = React.useState([])
    const [modalVisible, setModalVisible] = useState(false);
    const [totalPoints, setTotalPoints] = React.useState(null);
    const [pointsBalance, setPointsBalance] = React.useState(null);

    const handleOpenModal = (rowData: any) => {
        setSelectedPartner(rowData);
        setModalVisible(true);
    };

    const handleModalOk = () => {
        setModalVisible(false); 
    };

    const handleModalCancel = () => {
        setSelectedPartner([]);
        setModalVisible(false);
    };

    const columns = [
        // hide for now
        // {
        //     title: 'Date & Time',
        //     dataIndex: 'dateAndTime',
        //     key: 'dateAndTime',
        //     sorter: (a: any, b: any) => moment(a.dateAndTime).unix() - moment(b.dateAndTime).unix(),
        //     render: (date: any) => {
        //         return (
        //             <div>
        //                 <span>
        //                     {moment(date).format('ddd MMM D YYYY')}
        //                 </span>
        //                 <br />
        //                 <span className="text-neutralBlack-10">
        //                     {date}
        //                 </span>
        //             </div>
        //         )
        //     },
        // },
        {
            title: 'Partner',
            dataIndex: 'partner',
            key: 'partner',
        },
        {
            title: 'Available balance',
            dataIndex: 'availableBalance',
            key: 'availableBalance',
            render: (data: any) => {
                return (
                    <span>
                        {data.toLocaleString()}
                    </span>
                )
            },
        },
        {
            title: 'Awarded points (this week)',
            dataIndex: 'awardedPoints',
            key: 'awardedPoints',
            render: (data: any) => {
                return (
                    <span>
                        {data.toLocaleString()}
                    </span>
                )
            },
        },
        {
            title: 'Redeemed points (this week)',
            dataIndex: 'redeemedPoints',
            key: 'redeemedPoints',
            render: (data: any) => {
                return (
                    <span>
                        {data.toLocaleString()}
                    </span>
                )
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 250,
            render: (rowData: any) => {
                return (
                    <Button
                        className="px-4 text-highlight hover:underline hover:bg-neutralWhite active:bg-highlight-hovered active:no-underline hover:border-highlight hover:text-highlight h-10 text-xs sm:text-sm md:text-base p-2 sm:p-3 flex items-center justify-center w-full sm:w-auto font-poppinsMedium"
                        style={{
                            background: 'white',
                            borderColor: '#FF6F0B'
                        }}
                        onClick={() => {
                            handleOpenModal(rowData);
                        }}                    >
                        <Download size={20} className="h-4 mr-1 -ml-1"/>
                        Download report
                    </Button>

                );
            }
        },
    ]

    const getListOfPartners = useCallback(async () => {
        try {
            setLoading(true);
            const response = await onGetListOfPartners();
            
            if(response) {
                const data = response.items;

                const listOfPartners = data.map((item: any) => ({
                    key: item.id,
                    partner: item.doing_business_as,
                    availableBalance: item.points.balance,
                    awardedPoints: item.points.ern_pts,
                    redeemedPoints: item.points.rdm_pts,
                    action: item
                }));

                setPartners(listOfPartners);
            } else {
                setPartners([]);
            }
        } catch (e) {
            setPartners([]);
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [onGetListOfPartners, setPartners, setLoading]);

    const handleSearch = () => {
        getListOfPartners();
    };

    const filterPartners = (partner: any) => {
        const lowerCaseSearchText = searchText.toLowerCase();
    
        const matchesSearchText = partner.partner.toLowerCase().includes(lowerCaseSearchText);
    
        return matchesSearchText;
    };
    
    const locale = {
        emptyText: <Empty />,
    };

    const pointsToltipContent = (
        <div className="p-2 popver-div">
            <div className="text-neutralGray font-poppinsMedium text-header5 flex items-left">
                <img className="mr-2 mt-1" style={{ height: '18px' }} src={starIcon} alt="Points in Circulation Icon" />
                Points in Circulation
            </div>
             
            <p className="text-neutralGray-75 font-poppinsRegular mt-1 mt-2">
                This is the total points in
                <br />
                circulation distributed to
                <br />
                existing partners and users.
            </p>
        </div>
    );

    const getPointCardValues = useCallback(async () => {
        try {
            const response = await onGetOperationsPointsValues();

            if(response) {
                setTotalPoints(response.points.ern_pts)
                setPointsBalance(response.points.balance)
            }
        } catch (e) {
            setTotalPoints(null)
            setPointsBalance(null)
            console.error(e);
        } finally {
            return;
        }
    }, [onGetOperationsPointsValues]);

    React.useEffect(() => {
        getListOfPartners();
    }, [searchText, getListOfPartners])

    React.useEffect(() => {
        getPointCardValues();
    }, [getPointCardValues])

    return (
        <div>
            { loading && <Spin/> }    
            <div className="flex flex-row justify-between items-center">
            <div className="text-header1 pt-16 font-poppinsSemiBold text-neutralBlack">List of partners</div>
                <div className="flex justify-between">
                    <Card className="mr-4 p-0" style={{ width: 'fit', height: '116px', display: 'flex', alignItems: 'center' }}>
                        <Space>
                            <img className="mr-2" style={{ height: '50px' }} src={giftLogo} alt="Points Gift Logo" />
                            <div>
                                <div className="balances-card">Total points awarded this week</div>
                                <div className="text-neutralBlack text-header1 font-poppinsSemiBold">{totalPoints?.toLocaleString()}</div>
                            </div>
                        </Space>
                    </Card>
                    <Card className="p-0" style={{ width: 'fit', height: '116px', display: 'flex', alignItems: 'center' }}>
                        <Space>
                            <img className="mr-2" style={{ height: '50px' }} src={boxIcon} alt="Points Balance Logo" />
                            <div>
                                <div className="balances-card">
                                    Points in Circulation
                                    <Popover placement="bottomLeft" content={pointsToltipContent}>
                                        <InfoCircleOutlined className="info-circle-icon cursor-pointer" style={{ verticalAlign: 'middle'}} />
                                    </Popover>
                                </div>
                                <div className="text-neutralBlack text-header1 font-poppinsSemiBold">{pointsBalance?.toLocaleString()}</div>
                            </div>
                        </Space>
                    </Card>
                </div>
            </div>
            <div className="mt-10">
                <div className="py-6 px-4 bg-neutralWhite-pure flex items-center">
                    <Input
                        placeholder="Search"
                        allowClear
                        onChange={(e) => setSearchText(e.target.value)}
                        onPressEnter={handleSearch}
                        style={{ width: 250, height: 40, marginRight: 16 }}
                        prefix={<SearchOutlined style={{ marginRight: 8, color: '#94a3b8' }} />}
                    />
                </div>
                <Table
                    columns={columns}
                    dataSource={partners.filter(filterPartners)}
                    locale={locale}
                    scroll={{ y: 700 }}
                    pagination={{ position: ['bottomRight'] }}
                >
                </Table>
                <OperationsDownloadReports
                    onOkCallback={handleModalOk}
                    selectedPartner={selectedPartner}
                    open={modalVisible}
                    onClose={handleModalCancel}
                />
            </div>
        </div>
    )
}